import React from 'react';
import logo from '../../../img/img-hero2.jpg';
import sponser from '../../../img/Logo-yelp.jpg';
import Form_Azucarai from '../../form_azucarai';


const Hero = () => {
    return (
        <section className="pt-32 pb-20 bg-gradient-to-r from-red-50 to-cyan-50">
            <div className="container mx-auto px-6 flex flex-col md:flex-row items-center">
                <div className="md:w-1/2 mb-10 md:mb-0">
                    <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">

                        <span className="text-red-600">Yelp Experts Powered by AI </span>
                        Smart automation that turns Yelp leads into loyal customers.
                    </h1>
                    <p className="text-lg md:text-xl text-gray-600 mb-8">
                        Bold Design. Smart Strategy. Real Results. Let’s Grow Your Busines
                    </p>
                    <p className="text-lg md:text-xl text-gray-600 mb-8">SEO • Social Media • Reviews • AI Marketing • Web Design</p>

                    <button className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full transition duration-300 transform hover:scale-105">
                        Discover our services
                    </button>
                    <img
                        src={sponser}
                        alt="sponsers"
                        className="rounded-3xl mt-10 my-2 shadow-2xl w-[70px]"
                    />
                    <p className="text-sm md:text-sm text-gray-600 mb-8">Official Yelp Advertising Partner</p>
                </div>
                <div className="md:w-1/2 max-h-[500px] flex justify-center items-center">

                    <Form_Azucarai />


                </div>
            </div>
        </section>
    );
};

export default Hero;